<template lang="pug">
    h1 Nuevo Componente
</template>

<script>
import InvoiceService from '@/services/api/purchaseInvoice'
import { mapActions } from 'vuex'
export default {
    name: 'show-invoice',
    props: {},
    data: function() {
        return {}
    },
    computed: {},
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
    },
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: async function() {
        let invoice = await InvoiceService.fetchById(this.$route.params.invId)
        console.log({ invoice })
        this.setTitleTopBar(
            `${invoice.pch_provider.alias_name} - Factura de compra N°${
                invoice.invoice_number
            }`
        )
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>